import { authPost } from "../redux/ApiClient";

const baseUrl = "http://35.240.204.237/ok99memberApi/api";

export function fetchWalletInfo(params) {
  return authPost(`${baseUrl}/Member2/SingleWalletInfo`, params);
}
// export function fetchPromotionReviewInfo(params) {
//   return authPost(`${baseUrl}/Member8/PromoDialogUrl`, params);
// }
